<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      :loading="importHandleLoading"
      :loading-text="importHandleLoadingText"
      size="normal">
    <template #header>
      <span v-if="form.shipPlanImportType==='msku'">导入产品-按MSKU导入商品</span>
      <span v-if="form.shipPlanImportType==='fnsku'">导入产品-按FNSKU导入商品</span>
    </template>
    <template #content>
      <gj-upload
          :template-url="'/supply/shipPlan/download/import/'+ (form.shipPlanImportType === 'msku' ? '' : 'fnsku/' ) +'template/'+form.countryCode "
          @uploadAfter="uploadAfter"
          container-type="TRANSFER"
          style="margin-bottom: 10px;">
        <template #tip>
          <span>只能上传xls/xlsx文件</span>
        </template>
      </gj-upload>
      <gj-import-alert
          :rules="[
            '支持导入格式为xls/xlsx的文件',
            '您可以选择按MSKU导入商品，或按FNSKU导入商品；但同时只能使用其中一种方式',
            '如您的导入表格，同一个MSKU/FNSKU存在多条记录，则以第一条记录为准导入系统'
          ]">
      </gj-import-alert>
    </template>
  </gj-modal>
</template>

<script>
import {modalMixIn, uploadMixin} from "@/minxins";
import {postImportProducts} from "@/api/logistics";

export default {
  name: "delivery-plan-add-import",
  mixins: [modalMixIn, uploadMixin],
  data() {
    return {}
  },
  props: {
    form: {
      required: true,
      default: Object
    },

  },
  methods: {
    uploadAfter(attId, data, uploadCb) {
      this.importHandleLoading = true;
      postImportProducts(attId,this.form)
          .then((res) => {
            this.$gjImportHandle(res, uploadCb)
          }).catch(() => {
            uploadCb('error')
          })
          .complete(() => this.importHandleLoading = false);
    }
  }
}
</script>

<style scoped>

</style>
